import { useEffect, useState } from 'react'
import clsx from 'clsx'

import Link from '@/atoms/Link/Link'

/* utils */
import { HeaderProps } from './Header'

/* assets */
import { ReactComponent as PepperLogo } from 'public/assets/icons/PepperLogo.svg'

/* styling */
import styles from '@/molecules/Header/mobile.module.css'

const MEDIUM_SCREEN_SIZE = 768

function InfluencerMobileHeader({
  className,
  primaryCta,
  secondaryCta,
  leaderLinkList
}: HeaderProps): JSX.Element {
  const [menuVisibility, setMenuVisibility] = useState(false)
  const [activeAccordion, setActiveAccordion] = useState<string | number>()

  useEffect(() => {
    if (menuVisibility) {
      document.body.classList.add('overflow-hidden')
    } else {
      document.body.classList.remove('overflow-hidden')
      setActiveAccordion('')
    }
  }, [menuVisibility])

  useEffect(() => {
    // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/#css-custom-properties-the-trick-to-correct-sizing
    const getViewportHeight = () => {
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }

    getViewportHeight()

    if (window.innerWidth <= MEDIUM_SCREEN_SIZE) {
      window.addEventListener('resize', getViewportHeight)
    }
    return () => window.removeEventListener('resize', getViewportHeight)
  }, [])

  const toggleNav = () => setMenuVisibility(!menuVisibility)

  return (
    <section
      className={clsx(
        'sticky top-0  |  h-18  |  px-5 mx-auto  |  bg-white  |  z-50',
        menuVisibility && 'active',
        className
      )}
    >
      <div className="flex justify-between items-center | h-full">
        <Link href="/" className="pt-4 mb-6" title="Homepage">
          <PepperLogo style={{ width: 169, height: 32 }} />
        </Link>

        {/* prettier-ignore */}
        <div className={clsx(styles.hamburger, menuVisibility && 'active')} role="button" aria-label="Toggle Navigation" tabIndex={0} id="hamburger" onClick={toggleNav} onKeyPress={toggleNav}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      {/* menu items */}
      <nav
        className={clsx(
          'py-4 | bg-white | select-none | z-50 | overflow-y-auto',
          menuVisibility && 'active',
          styles.mobileNavDropdown
        )}
      >
        {leaderLinkList.map(({ id, title, href }) => {
          return (
            <Link
              key={id}
              href={href}
              className={clsx('font-heading', styles.menuItem)}
            >
              {title}
            </Link>
          )
        })}

        <div
          className={clsx(
            'grid grid-cols-1 md:grid-cols-2 justify-items-stretch gap-4 | fixed bottom-6 left-5 right-5  |  transition-all',
            activeAccordion && 'translate-y-20 | opacity-0 | invisible'
          )}
        >
          {secondaryCta ? (
            <Link
              href={secondaryCta.url}
              target="_blank"
              className="btn-secondary | btn-size-default whitespace-nowrap rounded-md"
            >
              {secondaryCta.title}
            </Link>
          ) : null}
          {primaryCta ? (
            <Link
              href={primaryCta.url}
              target="_blank"
              className="btn-primary | btn-size-default whitespace-nowrap rounded-md"
            >
              {primaryCta.title}
            </Link>
          ) : null}
        </div>
      </nav>
    </section>
  )
}

export default InfluencerMobileHeader
